import React from 'react';
import classNames from 'classnames';

import css from './IconChildFriendly.module.css';

export const IconChildFriendly = ({ rootClassName, className }) => {
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg className={classes} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
      <path d="M35.74 3.1 35 2.69a5.72 5.72 0 0 0-6.45.69s-1 .9-1 .93l-4.49 4.3A9.66 9.66 0 0 0 8.19 10a1.34 1.34 0 0 0-.16.6 1.38 1.38 0 0 0 .28.8l5.78 5.79-9.73 9.37A2 2 0 0 0 5.74 30h4.52l-1.54 2a2.31 2.31 0 0 0-.46 0 3 3 0 1 0 2.23 1l2.27-3h6L21 33a3 3 0 0 0 2.24 5 3 3 0 1 0 0-6 2.5 2.5 0 0 0-.47 0l-1.58-2.11a9.1 9.1 0 0 0 8.05-9V5.43l.61-.55A3.7 3.7 0 0 1 34 4.45l.75.41a1 1 0 0 0 1-1.76ZM8.26 36a1 1 0 1 1 1-1 1 1 0 0 1-1 1Zm2-25.43A7.66 7.66 0 0 1 21.61 10l-6.07 5.84Zm14 24.43a1 1 0 1 1-1-1 1 1 0 0 1 1 1Zm3-14.08A7.09 7.09 0 0 1 20.18 28H5.74L27.26 7.35Z" />
    </svg>
  );
};

export default IconChildFriendly;
